<template >
  <div class="process">
		<div class="new_page" v-show="!dialogVisible">
			<div class="new_left">
				<div class="search">
				  <div class="condition">
				  	<el-select v-model="searchForm.processType" placeholder="请选择" size="mini" style="width: 110px;">
				  		<el-option label="全部类型" value=""></el-option>
				  		<el-option label="采伐证审批" value="采伐证审批"></el-option>
				  		<el-option label="用火审批" value="用火审批"></el-option>
				  	</el-select>
				  </div>
				  <div class="condition">
				  	<el-date-picker
									style="width: 200px;"
									size="mini"
				  				@change="timeChange"
				  	      v-model="date"
				  	      type="daterange"
				  				value-format="yyyy-MM-dd"
				  	      range-separator="至"
				  	      start-placeholder="开始日期"
				  	      end-placeholder="结束日期">
				  	</el-date-picker>
				  </div>
				  <div class="condition">
				  	<el-input placeholder="请输入关键字" size="mini" v-model="searchForm.key">
				  	   <el-select v-model="searchForm.processName" slot="prepend" placeholder="请选择" style="width: 110px;">
				  	     <el-option label="流程名称" value="1"></el-option>
				  	   </el-select>
				  	 </el-input>
				  </div>
				 <div class="condition">
					 <el-button type="success" size="mini" @click="getList">搜 索</el-button>
					 <el-button type="success" size="mini"  @click="openAddProcess">新增</el-button>
				 </div>
				</div>
				<div class="table">
				  <el-table :data="tableData"  v-loading="loading" element-loading-text="数据加载中..." height="750px" align="center" @row-click="rowDetail" :header-cell-style="{background:'#f4f7fe'}" :row-style="{'cursor':'pointer'}">
						 <el-table-column prop="name" label="流程名称" ></el-table-column>
						 <el-table-column prop="flowchartTypeName" label="类型" ></el-table-column>
						 <el-table-column prop="createTime" label="时间" ></el-table-column>
						 <el-table-column prop="state" label="状态" >
							 <template slot-scope="scope">
								 <el-tag type="danger" v-if="scope.row.state === 0">关闭</el-tag>
								 <el-tag type="success" v-else>启用</el-tag>
							 </template>
						 </el-table-column>
				    <el-table-column label="操作" align="right">
				      <template slot-scope="scope">
								<el-button @click.stop="edit(scope.row)" type="success" size="small"
								  >修改</el-button
								>
				        <!-- <el-button @click="rowDetail(scope.row)" type="success" size="small"
				          >详情</el-button
				        > -->
				        <el-button @click.stop="deleteRowData(scope.row)" type="success" size="small"
				          >删除</el-button
				        >
				      </template>
				    </el-table-column>
				  </el-table>
				</div>
				<div class="page">
					<el-pagination
					      @size-change="handleSizeChange"
					      @current-change="handleCurrentChange"
					      :current-page.sync="currentPage"
					      :page-sizes="[10, 20, 50]"
					      layout="sizes, prev, pager, next"
					      :total="total">
					    </el-pagination>
				</div>
			</div>
			<div class="new_right">
				<Dialog  ref="processDetail"  />
			</div>
		</div>
		<AddProcess ref="process" :template="tableData" :dialogType="dialogType"  @close-dialog="dialogVisible = false" @dialog-confirm="handleAddConfirm"  v-show="dialogVisible" />
  </div>
		
</template>

<script>
import { GetFlowchartList,IsUse,GetDetails,DeleteFlowchart } from "../../api/Flowchart.js";
import Dialog from "./components/process.vue"
import AddProcess from "./components/addProcess.vue"

export default {
  name: "processManage",
  components: {
    Dialog,
		AddProcess
  },
  data() {
    return {
      searchForm:{
      	processType:"",
      	key:'',
      	startTime:'',
      	endTime:'',
				processName:"1"
      },//搜索表单
      date:'',
      loading: false, // 数据是否处于加载状态
      tableData: [], // 表格数据
      total: 0, // 数据总数
      currentPage: 1, // 当前页数
      pageSize: 10, // 当前查询数据个数
			detailMoadl:true,//详情
      dialogVisible: false, // 新增对话框是否显示
			dialogType:'add'
    };
  },
	computed:{
		user() {
			return this.$store.state.user;
		},
	},
  mounted() {
    this.getList();
		this.$nextTick(()=>{
			this.$refs.process.getZhen()
		})
  },
  methods: {
		// 选择时间
		timeChange(e){
			if(e){
				this.searchForm.startTime = e[0]
				this.searchForm.endTime = e[1]
			}else{
				this.searchForm.startTime = ''
				this.searchForm.endTime = ''
			}
		},
		// 分页查询
		handleSizeChange(e){
			this.pageSize = e
			this.getList()
		},
		handleCurrentChange(e){
			this.currentPage = e
			this.getList()
		},
    /*获取所有数据列表 */
    async getList() {
			this.loading = true
      try {
        let params = {
          pageNumber: this.currentPage,
          pageSize: this.pageSize,
          keyword: this.searchForm.key,
					startTime:this.searchForm.startTime,
					endTime:this.searchForm.endTime,
					processType: this.searchForm.processType
        };
        let { data } = await GetFlowchartList(params);
        if(data.state === 1) {
          data = data.data
          this.tableData = data.lis
          this.total = data.count
					this.loading = false
					if(this.tableData.length>0){
						this.$refs.processDetail.getProcessDetail(this.tableData[0].id)
					}else{
						this.$refs.processDetail.getProcessDetail('')
					}
        }else{
					this.loading = false
					this.$message.error(data.msg)
				}
      } catch (err) {
        // this.$message.error("获取采伐证列表列表失败,请稍后重试!");
      }
    },
		// 打开新增流程
		openAddProcess(){
			this.$refs.process.getOperateType()
			this.dialogType = 'add'
			this.dialogVisible = true
		},
		handleAddConfirm(){
			this.dialogVisible = false
			this.getList()
		},
		// 编辑
		edit(row){
			IsUse(row.id).then(res=>{
				if(res.data.state==1){
					if(!res.data.data){
						this.$refs.process.getProcessDetail(row.id)
						this.$refs.process.getOperateType()
						this.dialogType = 'edit'
						this.dialogVisible = true
					}else{
						this.$refs.process.getProcessDetail(row.id,true)
						this.$refs.process.getOperateType()
						this.dialogType = 'edit'
						this.dialogVisible = true
					}
				}
			})
		},
    /* 数据详情 */
    rowDetail(row) {
			this.$refs.processDetail.getProcessDetail(row.id)
    },
    /* 通过ID删除单行数据 */
     deleteRowData(row) {
      IsUse(row.id).then(res=>{
				if(res.data.state==1){
					if(!res.data.data){
						this.$confirm('确定删除？', '提示', {
						  confirmButtonText: '确定',
						  cancelButtonText: '取消',
						  type: 'warning'
						}).then(() => {
						  DeleteFlowchart(row.id).then(res=>{
						  	if(res.data.state==1){
						  		this.$message.success('操作成功')
						  		this.getList()
						  	}else{
									this.$message.erroe(res.data.msg)
								}
						  })
						}).catch(()=>{})
					}else{
						this.$message.error('该流程正在使用中，暂不可删除')
					}
				}
			})
    }
  },
};
</script>
<style lang="less" scoped>
.process {
  height: 100%;
	.new_page{
		width: 100%;
		height: 100%;
		display: flex;
		.new_left {
			width: 50%;
			height: 100%;
			margin-right: 10px;
			margin-left: 10px;
			.search {
				display: flex;
				align-items: center;
				justify-content: space-between;
				flex-wrap: wrap;
				padding: 10px 10px;
			}
			.info {
				.table {
					height: calc(100vh - 185px)
				}
				.page {
					display: flex;
					justify-content: space-between;
					align-items: center;
					margin: 0px 10px;
					margin-top:4px ;
				}
			}
		}
		.new_right {
			width: 50%;
			height: 100%;
			background-color: #f4f7fe;
		}
	}
 // .search {
 //    padding: 30px;
	// 	display: flex;
	// 	align-items: center;
	// 	.condition {
	// 		display: flex;
	// 		align-items: center;
	// 		margin-right: 20px;
	// 	}
 //  }
 //  .table {
 //    padding: 0px 30px 0px 30px;
 //  }
 //  .page {
 //    text-align: center;
 //  }
  /deep/ .el-dialog__header {
    padding: 10px;
    background-color: #5bacf0;
  }
  /deep/ .el-dialog__title {
    color: #fff;
  }
  /deep/ .el-dialog__body {
    padding: 15px;
  }
  /deep/ .el-dialog__footer {
    padding: 0px 10px 10px 10px;
  }
}
</style>
